import React from "react";
import { SiteHeader } from "./components/sections/SiteHeader";
import { Hero } from "./components/sections/Hero";
import { CareerExplorer } from "./components/sections/CareerExplorer";
import { CommunityImpact } from "./components/sections/CommunityImpact";
import { LifeAtBigYellow } from "./components/sections/LifeAtBigYellow";
import { CrewGallery } from "./components/sections/CrewGallery";
import { ProjectExperience } from "./components/sections/ProjectExperience";
import { FleetFeature } from "./components/sections/FleetFeature";
import { HowItWorks } from "./components/sections/HowItWorks";
import { CandidateFAQ } from "./components/sections/CandidateFAQ";
import { FinalCTA } from "./components/sections/FinalCTA";
import { SiteFooter } from "./components/sections/SiteFooter";
import { SectionDivider } from "./components/SectionDivider";
import { ExpressionOfInterestDialog } from "./components/ExpressionOfInterestDialog";
import { MobileActionBar } from "./components/MobileActionBar";
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-black antialiased" data-id="element-0" data-mp="3ijpcgysnsv8p">
      <SiteHeader data-id="element-1" data-mp="3mk85gw6ag7ch" />
      <main id="main-content" data-id="element-2" data-mp="3mjq3rk0ux0x6">
        <Hero data-id="element-3" data-mp="3rc9i4j7dc031" />
        <CareerExplorer data-id="element-4" data-mp="3rbrbqtqzs5he" />
        <CommunityImpact data-id="element-5" data-mp="3rdkie91luppe" />
        <SectionDivider variant="yellow" from="#D58D33" to="#000000" data-id="element-6" data-mp="3recf5n6xuth9" />
        <LifeAtBigYellow data-id="element-7" data-mp="4n5i12o8na1" />
        <SectionDivider variant="ochre" from="#000000" to="#FFFFFF" flip data-id="element-8" data-mp="82ld64660ci" />
        <CrewGallery data-id="element-9" data-mp="2zmemy5wtxg6g" />
        <SectionDivider variant="yellow" from="#FFFFFF" to="#FDF3D6" data-id="element-10" data-mp="2zn6actg9w7ln" />
        <ProjectExperience data-id="element-11" data-mp="33ngee0ki8nxv" />
        <SectionDivider variant="strata" from="#FDF3D6" to="#000000" data-id="element-12" data-mp="33orik1hv3xpi" />
        <FleetFeature data-id="element-13" data-mp="38l05i12awv78" />
        <SectionDivider variant="gold" from="#000000" to="#FDF3D6" flip data-id="element-14" data-mp="38nuorp9kw9z2" />
        <HowItWorks data-id="element-15" data-mp="3dlns8ajhypvn" />
        <SectionDivider variant="ochre" from="#FDF3D6" to="#FFFFFF" data-id="element-16" data-mp="3dm5vhr4ku4d2" />
        <CandidateFAQ data-id="element-17" data-mp="nuhjilyq8hvv" />
        <SectionDivider variant="strata" from="#FFFFFF" to="#000000" data-id="element-18" data-mp="nvas7sh8xhgn" />
        <FinalCTA data-id="element-19" data-mp="stkoy7imcq4d" />
      </main>
      <SiteFooter data-id="element-20" data-mp="ssstcwp0use3" />
      <ExpressionOfInterestDialog data-id="element-21" data-mp="36hwt7ylgu1r" />
      <MobileActionBar data-id="element-22" data-mp="35oy8u9shaup" />
    </div>;
}